import {SharedModule} from "../shared/shared.module";
import {NgModule} from "@angular/core";
import {NavLayoutComponent} from "./nav-layout/nav-layout.component";
import {HostManagerModule} from "../fonzie/hostmanager.module";
import {AuthGuardService} from "../fonzie/auth/auth-guard.service";
import {RoutingPageComponent} from "./routing-page.component";

@NgModule({
    imports: [
        SharedModule,
        HostManagerModule
    ],
    declarations: [
        NavLayoutComponent,
        RoutingPageComponent
    ],
    providers: [
        AuthGuardService
    ]
})
export class MainModule {
}
